var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1254,
    height: 1254,
    viewBox: "0 0 1254 1254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_18446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1254V1254H0V0Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.835 144.114C573.39 135.518 613.199 130.689 635.174 134.04C652.613 134.229 685.316 143.516 700.409 151.547C731.539 163.057 766.55 199.657 781.76 228.964C806.203 276.724 802.37 315.157 802.101 366.393C801.984 388.442 802.983 411.955 801.691 433.809C801.654 455.613 802.297 481.342 801.482 502.807C802.07 515.149 801.733 529.77 801.727 542.29L801.599 612.657L801.617 688.717C801.666 703.345 802.107 719.51 801.691 734.046C779.127 715.181 762.564 706.682 735.898 694.032C715.417 684.321 696.778 678.718 676.058 670.005C644.328 656.669 563.983 635.055 558.055 597.099C556.961 590.093 561.42 581.135 566.358 575.775C581.588 559.237 609.983 550.194 631.17 543.753C634.562 541.729 645.179 538.365 649.557 536.841C670.921 529.388 693.986 523.074 711.345 507.859C720.505 499.828 719.495 489.443 710.831 481.505C693.974 466.077 669.837 459.488 648.4 453.172C644.132 451.915 634.819 449.033 630.674 449.042C648.02 455.65 693.013 474.143 687.894 497.29C678.44 513.646 652.227 519.022 635.193 523.567C587.138 536.386 481.414 555.747 455.214 600.266C448.839 611.099 446.966 623.752 450.242 635.924C452.895 645.776 458.516 654.281 464.827 662.161C473.84 670.281 481.235 676.655 491.941 682.9C497.488 686.133 505.672 689.531 510.684 692.758C517.353 695.22 524.468 698.459 531.043 701.294C552.138 707.509 572.518 716.546 594.36 721.494C598.359 722.4 622.555 729.307 625.01 730.825L624.459 731.572L625.384 731.903C626.29 734.909 623.54 743.255 622.304 746.5C621.477 748.65 617.509 747.088 615.189 747.964C610.089 747.517 575.125 738.644 570.297 736.722C561.83 735.142 549.941 731.401 541.465 728.988C499.428 717.024 464.048 701.514 426.122 680.2C425.568 653.069 426.075 624.272 426.071 597.032L426.051 433.327L426.057 350.623C426.069 300.526 425.407 269.315 452.57 224.465C471.118 193.357 498.486 168.458 531.204 152.924C537.717 149.803 545.882 145.821 552.835 144.114Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.835 144.114C573.39 135.518 613.199 130.689 635.174 134.04C631.99 134.311 631.776 133.744 630.086 135.455C629.272 137.891 631.176 155.074 631.898 158.055C634.433 160.562 633.846 157.126 638.248 160.477C603.997 157.37 583.166 160.477 551.156 172.92C540.994 178.73 534.041 181.311 523.437 188.426C491.632 210.225 468.609 242.619 458.478 279.824C452.297 302.421 453.198 320.355 453.22 343.303L453.292 385.696C461.321 385.813 483.331 386.383 490.251 388.748C519.4 393.566 543.003 405.51 565.152 424.75C568.596 427.742 578.586 438.126 581.595 438.982C592.367 442.048 604.532 441.638 616.468 444.417C618.887 445.416 627.918 448.473 630.674 449.042C648.02 455.65 693.013 474.143 687.894 497.29C678.44 513.646 652.227 519.022 635.193 523.567C587.138 536.386 481.414 555.747 455.214 600.266C448.839 611.099 446.966 623.752 450.242 635.924C452.895 645.776 458.516 654.281 464.827 662.161C473.84 670.281 481.235 676.655 491.941 682.9C497.488 686.133 505.672 689.531 510.684 692.758C517.353 695.22 524.468 698.459 531.043 701.294C552.138 707.509 572.518 716.546 594.36 721.494C598.359 722.4 622.555 729.307 625.01 730.825L624.459 731.572L625.384 731.903C626.29 734.909 623.54 743.255 622.304 746.5C621.477 748.65 617.509 747.088 615.189 747.964C610.089 747.517 575.125 738.644 570.297 736.722C561.83 735.142 549.941 731.401 541.465 728.988C499.428 717.024 464.048 701.514 426.122 680.2C425.568 653.069 426.075 624.272 426.071 597.032L426.051 433.327L426.057 350.623C426.069 300.526 425.407 269.315 452.57 224.465C471.118 193.357 498.486 168.458 531.204 152.924C537.717 149.803 545.882 145.821 552.835 144.114Z",
    fill: "url(#paint0_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.478 497.732C779.837 494.062 778.937 459.871 778.931 452.961C782.538 453.509 798.133 454.901 800.276 455.697C801.188 466.07 799.547 495.425 801.482 502.8C802.07 515.142 801.733 529.763 801.727 542.283L801.599 612.65L801.617 688.71C801.666 703.338 802.107 719.503 801.691 734.039C779.127 715.174 762.564 706.675 735.898 694.025C715.417 684.314 696.778 678.712 676.058 669.998C644.328 656.662 563.983 635.048 558.055 597.093C556.961 590.086 561.42 581.129 566.358 575.768C581.588 559.231 609.983 550.187 631.17 543.746C635.168 543.422 649.998 539.13 654.296 537.963L706.495 523.584C731.245 517.228 755.345 508.573 778.478 497.732Z",
    fill: "url(#paint1_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.835 144.114C573.39 135.518 613.199 130.689 635.174 134.04C631.99 134.311 631.776 133.744 630.086 135.455C629.272 137.891 631.176 155.074 631.898 158.055C634.433 160.562 633.846 157.126 638.248 160.477C603.997 157.37 583.166 160.477 551.156 172.92L550.98 172.547L551.412 171.773C557.391 169.24 565.599 165.998 571.68 163.854C573.395 163.25 581.025 162.55 584.652 161.572C586.747 159.361 585.344 140.321 583.018 137.661C575.486 136.305 559.232 144.943 552.835 144.114Z",
    fill: "url(#paint2_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.174 134.04C652.613 134.229 685.316 143.516 700.409 151.547C731.539 163.057 766.55 199.657 781.76 228.965C806.203 276.724 802.37 315.157 802.101 366.393C801.984 388.442 802.983 411.955 801.691 433.809C801.654 455.613 802.297 481.342 801.482 502.807C799.547 495.432 801.188 466.077 800.276 455.703C798.133 454.907 782.538 453.516 778.931 452.968C778.937 459.877 779.837 494.069 778.478 497.739C777.97 495.375 778.056 487.501 778.031 484.642C777.394 469.079 777.798 451.786 777.805 436.023L777.786 354.271C777.774 335.76 778.594 315.6 776.476 297.298C774.81 282.883 770.047 270.24 765.577 256.649C758.731 242.937 752.002 230.286 742.395 218.191C737.313 211.797 729.426 205.674 724.895 199.608C717.125 193.886 710.42 188.059 702.081 182.837C697.323 179.858 687.759 175.897 683.902 173.046C667.1 166.405 656.342 163.109 638.248 160.477C633.846 157.126 634.433 160.562 631.898 158.055C631.176 155.074 629.272 137.891 630.086 135.455C631.776 133.744 631.99 134.311 635.174 134.04Z",
    fill: "url(#paint3_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.754 310.33C800.111 335.64 802.75 363.796 801.513 389.642C799.033 393.343 802.719 431.328 799.382 434.476C792.843 434.875 785.654 434.375 778.986 434.438C778.925 427.537 779.77 392.561 778.38 388.586C777.719 368.019 778.454 343.702 779.005 323.019C786.248 320.854 792.451 314.18 800.754 310.33Z",
    fill: "url(#paint4_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.174 134.04C652.613 134.229 685.316 143.516 700.409 151.547C695.468 152.003 666.837 137.285 661.118 139.711C661.099 140.304 660.928 143.948 660.732 144.207C658.105 147.692 656.446 158.742 654.891 161.268C662.312 164.568 679.462 167.337 683.902 173.046C667.1 166.405 656.342 163.109 638.248 160.477C633.846 157.126 634.433 160.562 631.898 158.055C631.176 155.074 629.272 137.891 630.086 135.455C631.776 133.744 631.99 134.311 635.174 134.04Z",
    fill: "url(#paint5_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.986 434.438C785.654 434.375 792.843 434.875 799.382 434.476C802.719 431.328 799.033 393.343 801.513 389.642C801.905 403.748 800.937 420.206 801.691 433.809C801.654 455.613 802.297 481.342 801.482 502.807C799.547 495.432 801.188 466.077 800.276 455.703C798.133 454.907 782.538 453.516 778.931 452.968C778.937 459.877 779.837 494.069 778.478 497.739C777.97 495.375 778.056 487.501 778.031 484.642L778.38 388.586C779.77 392.561 778.925 427.537 778.986 434.438Z",
    fill: "url(#paint6_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.895 199.608C731.863 200.991 757.292 234.007 759.05 241.527C761.493 245.132 765.43 252.336 765.577 256.649C758.731 242.937 752.002 230.286 742.395 218.191C737.313 211.797 729.426 205.674 724.895 199.608Z",
    fill: "url(#paint7_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.468 444.416C621.697 444.092 629.076 445.782 634.36 446.786C659.575 451.636 684.759 458.658 707.549 470.775C722.256 478.593 742.144 494.305 726.236 511.719C720.646 517.835 710.904 519.457 706.495 523.588L654.296 537.968C649.998 539.135 635.168 543.427 631.17 543.751C634.562 541.727 645.179 538.363 649.557 536.839C670.921 529.386 693.986 523.072 711.345 507.857C720.505 499.827 719.495 489.441 710.831 481.503C693.974 466.075 669.837 459.486 648.4 453.17C644.132 451.913 634.819 449.031 630.674 449.04C627.918 448.471 618.887 445.414 616.468 444.416Z",
    fill: "url(#paint8_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.29 342.317C649.68 363.244 628.91 376.413 608.012 371.657C587.118 366.902 574.091 346.04 578.99 325.178C583.889 304.316 604.84 291.434 625.665 296.476C646.092 301.421 658.815 321.793 654.29 342.317Z",
    fill: "url(#paint9_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.287 889.994C971.868 898.774 945.184 940.625 954.02 948.524C962.819 950.649 981.457 928.44 986.466 922.458C997.763 908.957 1005.04 892.621 1013.71 877.423C1027.59 852.607 1041.35 827.563 1057.53 804.149C1063.18 795.968 1069.56 787.286 1077.28 780.985C1081.81 777.287 1091.64 774.17 1096.47 778.738C1096.98 780.312 1097.25 782.155 1096.19 783.532C1088.56 793.476 1080.64 803.622 1073.53 813.915C1059.07 834.954 1045.3 856.452 1032.24 878.391C1027.11 887 1020.7 897.329 1016.18 906.159C1026.22 895.125 1052.85 869.145 1067.85 879.432C1082.24 889.302 1036.88 938.005 1047.16 949.296C1055.32 952.896 1069.54 940.503 1075.31 935.488C1079.3 932.01 1088.69 918.754 1092.93 918.258C1093.14 918.484 1093.95 919.06 1093.71 919.593C1086.58 935.415 1060.45 961.174 1041.63 957.947C1007.07 952.026 1054.94 897.648 1053.5 888.879C1050.04 885.965 1046.66 888.573 1043.03 890.802C1023.68 902.754 1009.16 922.042 998.112 941.623C995.718 945.971 994.083 951.279 990.783 954.99C987.562 958.609 976.816 958.737 977.171 952.663C977.514 946.822 983.349 937.252 986.086 932.022C977.061 941.366 962.959 957.629 949.262 957.733C933.655 957.856 936.557 942.144 939.043 932.543C933.759 938.935 928.964 945.071 922.382 950.214C905.421 963.446 888.932 960.917 893.224 936.021C885.123 945.401 873.759 956.398 860.845 957.813C844.687 959.588 846.769 942.53 850.216 932.188C841.086 942.897 830.193 956.411 815.265 958.425C806.607 959.631 801.311 951.977 801.55 944.036C802.046 927.467 814.396 910.329 825.613 898.958C836.494 887.924 860.202 870.7 874.157 885.732L874.732 886.357C879.159 885.806 885.601 880.662 889.385 887.649C887.94 894.011 850.136 946.185 867.036 949.357C877.972 946.491 892.232 929.634 898.747 920.768C903.609 914.149 908.354 905.675 914.391 900.023C922.713 890.471 942.913 875.109 957.767 880.368C959.494 880.981 961.827 884.906 963.768 886.253C968.195 883.148 976.069 882.113 978.212 888.114L977.287 889.994Z",
    fill: "url(#paint10_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.023 888.737C949.703 887.488 952.33 886.386 956.028 887.709C961.337 893.128 951.736 902.9 949.305 908.576L948.778 909.201C943.249 915.82 919.706 952.84 909.689 946.239C906.009 939.547 914.673 924.98 918.182 918.593C917.833 915.985 921.813 910.842 923.392 908.423C930.415 900.041 934.42 893.066 944.817 888.248L946.023 888.737Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.392 908.418C930.415 900.035 934.42 893.061 944.817 888.242L946.023 888.732C932.124 897.549 927.66 905.681 918.181 918.588C917.832 915.98 921.812 910.836 923.392 908.418Z",
    fill: "url(#paint11_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.391 900.021C922.713 890.469 942.912 875.106 957.767 880.366C959.494 880.978 961.827 884.903 963.768 886.25C968.195 883.146 976.069 882.111 978.212 888.111L977.287 889.991C976.761 886.734 974.354 883.929 970.711 884.34C962.831 885.24 952.997 907.001 949.305 908.575C951.736 902.899 961.337 893.126 956.028 887.707C952.33 886.385 949.703 887.487 946.023 888.736L944.817 888.246C934.42 893.065 930.415 900.039 923.392 908.422C919.939 905.911 934.744 901.564 922.884 893.739C919.682 896.059 918.004 898.833 914.391 900.021Z",
    fill: "url(#paint12_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.694 902.12C846.315 896.585 859.461 882.992 867.832 888.674C872.895 897.932 832.985 949.194 820.88 947.222C811.665 940.101 833.194 911.262 838.135 905.041L840.694 902.12Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.135 905.039C833.671 904.53 831.755 914.235 827.836 915.197L827.652 914.272C831.54 909.943 841.98 895.364 846.334 893.711C844.258 897.403 840.413 898.689 840.694 902.118L838.135 905.039Z",
    fill: "url(#paint13_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.482 741.151C358.992 740.055 383.69 741.781 393.323 754.524C407.346 773.076 391.545 799.246 375.928 811.284C363.82 820.616 353.793 823.836 338.734 822.104C356.971 814.413 369.463 804.549 379.003 786.78C385.862 774.925 384.582 758.13 370.281 752.705C332.982 738.549 262.7 769.115 247.325 804.996C223.614 860.324 328.011 878.381 341.482 924.45C345.859 939.421 345.833 949.806 339.298 964.305C305.159 1038.42 124.52 1062.02 92.8095 977.709C80.1642 925.301 131.955 889.531 178.596 886.42C183.069 886.126 197.609 885.41 201.081 888.496C200.938 890.822 193.4 890.957 191.201 891.184C153.834 894.411 110.686 925.559 114.571 966.816C119.02 1014.06 174.489 1025.03 213.147 1021.08C247.807 1017.54 282.187 1005.46 305.728 978.921C319.084 963.858 324.613 941.681 312.723 924.218C294.517 899.566 264.516 886.071 241.034 866.63C213.952 844.208 210.466 815.178 234.24 788.243C261.035 757.885 304.981 743.851 344.482 741.151Z",
    fill: "url(#paint14_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.376 931.784C404.316 944.844 388.834 962.742 370.007 961.983C360.366 961.597 357.155 950.367 358.334 942.352C361.316 922.067 376.787 903.391 392.333 890.937C402.819 882.536 417.908 874.301 431.737 875.813C437.965 876.652 439.294 878.948 442.781 883.473C444.841 884.281 450.309 880.84 453.551 881.575C455.523 881.159 458.715 885.23 457.921 886.737C452.13 897.74 422.308 939.432 430.492 950.6C431.797 951.439 433.139 952.137 434.82 951.733C450.025 948.077 471.964 921.069 480.918 908.835C485.024 903.226 493.601 886.486 497.292 880.112C512.325 853.923 527.391 827.594 545.374 803.292C551.319 795.258 565.289 783.68 575.063 791.878C575.01 794.897 563.857 807.878 560.85 812.207C547.873 831.029 535.402 850.194 523.448 869.678C517.317 879.634 511.28 890.588 504.903 900.25L502.225 905.338L502.648 905.008C517.851 892.854 531.862 876.481 554.077 877.564C564.056 878.048 567.534 889.896 565.835 898.101C563.764 909.098 557.845 922.165 551.323 931.221C548.902 932.862 530.861 935.568 528.667 934.882C534.253 925.11 552.02 900.942 547.951 889.761C535.637 875.985 495.118 921.062 489.962 931.821C488.026 935.856 477.189 959.742 476.757 960.128C474.53 960.354 473.004 960.458 470.807 959.742C468.866 959.123 467.296 957.678 466.508 955.798C463.573 948.941 469.824 935.513 472.533 928.612C463.485 939.334 452.516 950.257 440.275 957.397C432.121 962.148 419.237 964.873 413.864 954.458C410.412 947.759 413.264 938.636 415.376 931.784Z",
    fill: "url(#paint15_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.225 905.338C501.344 905.926 499.199 909.924 496.942 912.116C497.83 909.086 501.93 901.23 504.903 900.25L502.225 905.338Z",
    fill: "url(#paint16_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.535 885.669C441.987 879.913 437.967 890.635 430.134 901.803C422.601 912.543 392.241 955.006 378.717 950.653C372.107 945.375 382.479 927.894 385.477 922.248C384.582 915.709 414.942 882.852 422.535 885.669Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.477 922.25C384.583 915.71 414.942 882.854 422.535 885.671C406.533 894.525 395.741 907.359 385.477 922.25Z",
    fill: "url(#paint17_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.794 897.279C762.509 895.191 794.122 880.814 816.343 856.487C831.749 839.624 845.605 808.727 824.707 790.278C810.312 778.234 785.979 776.538 767.928 778.773C718.393 784.89 668.043 804.361 633.613 841.92C613.725 863.614 610.606 903.426 651.645 901.069C654.033 900.934 657.793 899.091 659.752 899.93C660.181 907.669 641.769 907.333 636.656 907.02C616.438 905.79 598.618 890.243 601.454 868.537C606.543 829.588 655.025 803.241 687.992 790.119C722.642 776.33 761.162 767.96 798.311 770.899C826.354 773.152 857.245 788.386 852.922 821.383C846.762 868.415 796.266 896.268 753.459 902.673C746.644 903.72 740.252 904.192 733.621 905.067C732.078 903.347 730.063 900.414 729.236 898.24L729.794 897.279Z",
    fill: "url(#paint18_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.258 896.681C674.686 893.834 666.555 884.735 675.648 880.749C685.022 876.646 691.696 898.187 700.464 894.44C702.381 896.656 703.82 896.797 707.022 896.864C709.937 896.926 716.758 897.82 719.121 897.618L729.794 897.281L729.237 898.242C730.063 900.416 732.078 903.349 733.621 905.069C741.452 916.189 748.616 926.163 757.948 936.168C800.711 982.018 860.552 1004.91 921.164 1015.67C930.348 1017.3 939.508 1018.35 948.729 1019.7C942.037 1021.7 939.643 1018.28 934.304 1019.2C933.857 1022.64 933.655 1027.45 933.526 1030.95C937.824 1032.28 942.79 1031.8 947.419 1033L947.272 1033.72C924.194 1032.76 881.756 1023.07 860.025 1016.25C812.773 1001.41 763.483 974.345 733.192 934.307C728.067 927.529 723.273 921.785 719.232 914.07C717.438 911.664 716.684 908.67 714.486 907.292C712.766 907.8 713.096 908.076 711.823 910.035C708.878 905.504 706.171 905.663 701.077 904.396L695.474 902.442C689.29 900.869 685.781 899.846 680.258 896.681Z",
    fill: "url(#paint19_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.258 896.68C685.426 896.833 693.558 901.333 699.038 902.423C705.62 903.727 712.361 904.187 718.895 905.387C718.166 906.36 718.484 905.999 717.217 906.544C717.774 909.795 719.464 911.559 719.232 914.069C717.437 911.663 716.684 908.669 714.486 907.291C712.766 907.799 713.096 908.075 711.823 910.034C708.877 905.503 706.171 905.662 701.077 904.395L695.474 902.441C689.29 900.868 685.781 899.845 680.258 896.68Z",
    fill: "url(#paint20_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.474 902.438L701.077 904.391C706.171 905.658 708.877 905.499 711.823 910.03C710.261 913 709.33 914.494 707.414 917.249C706.496 919.735 695.272 937.621 692.97 941.588C685.708 953.663 679.168 966.178 671.723 978.143C663.2 991.846 653.782 994.032 638.701 993.702C657.83 969.35 678.421 930.199 695.474 902.438Z",
    fill: "url(#paint21_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.077 904.391C706.171 905.658 708.877 905.499 711.823 910.03C710.261 913 709.331 914.494 707.414 917.249C707.634 915.7 707.751 914.855 707.794 913.3C706.226 909.491 703.961 907.305 701.077 904.391Z",
    fill: "url(#paint22_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.464 894.434C710.298 878.042 720.628 861.583 731.367 845.786C739.67 833.564 759.956 802.508 777.547 815.189L777.78 816.383C773.586 820.73 767.059 826.064 763.575 830.362C746.614 851.327 733.547 875.152 719.121 897.611C716.758 897.813 709.937 896.919 707.022 896.858C703.82 896.791 702.381 896.65 700.464 894.434Z",
    fill: "url(#paint23_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.348 1022.07C1021.43 1021.81 1037.34 1020.1 1062.09 1016.91C1060.73 1018.23 1059.59 1018.23 1057.82 1018.57C1056.77 1020.92 1056.84 1019.79 1057.11 1022C1061.99 1026.75 1071.89 1021.48 1077.95 1025.75C1078.61 1027.19 1078.78 1027.34 1078.97 1028.88C1059.65 1032.42 1031.58 1036.49 1011.75 1036.23C1001.35 1036.9 956.169 1036.28 947.272 1033.72L947.419 1033C942.79 1031.8 937.824 1032.27 933.526 1030.95C933.654 1027.45 933.857 1022.64 934.304 1019.2C939.643 1018.28 942.037 1021.7 948.729 1019.7C965.482 1020.53 979.057 1022.06 996.348 1022.07Z",
    fill: "url(#paint24_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.348 1022.07C1021.43 1021.81 1037.34 1020.1 1062.09 1016.91C1060.73 1018.23 1059.59 1018.23 1057.82 1018.57C1056.77 1020.92 1056.84 1019.79 1057.11 1022C1061.99 1026.75 1071.89 1021.48 1077.95 1025.75C1078.61 1027.19 1078.78 1027.34 1078.97 1028.88C1059.65 1032.42 1031.58 1036.49 1011.75 1036.23C1007.14 1035.98 1002.54 1035.78 997.928 1035.63C1003.06 1035.29 1016.41 1035.2 1020.27 1034.49C1016.03 1030.84 1018.2 1025.02 1014.77 1023.29C1011.8 1021.79 995.785 1024.61 993.011 1022.76L996.348 1022.07Z",
    fill: "url(#paint25_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.98 950.242C1149.89 956.004 1154.49 961.698 1155.16 971.018C1157.65 1005.19 1112.52 1020.51 1087.39 1026.74L1078.97 1028.88C1078.78 1027.34 1078.61 1027.19 1077.95 1025.75C1071.89 1021.48 1061.99 1026.75 1057.11 1022C1056.84 1019.79 1056.77 1020.92 1057.82 1018.57C1059.59 1018.23 1060.73 1018.23 1062.09 1016.91C1064.23 1016.02 1080.52 1012.99 1084.54 1011.94C1097.35 1008.61 1106.91 1005.01 1118.94 999.527C1130.12 992.957 1143.34 985.26 1146.94 971.746C1149.16 963.468 1146.3 957.498 1142.98 950.242Z",
    fill: "url(#paint26_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.61 996.355C1125.27 1002.81 1124.19 1006.18 1118.82 1010.6C1109.86 1012.6 1092.24 1017.89 1086.48 1024.83C1086.72 1026.23 1086.44 1025.58 1087.39 1026.74L1078.97 1028.88C1078.78 1027.34 1078.61 1027.19 1077.95 1025.75C1071.89 1021.48 1061.99 1026.75 1057.11 1022C1056.84 1019.79 1056.77 1020.92 1057.82 1018.57C1059.59 1018.23 1060.73 1018.23 1062.09 1016.91C1064.23 1016.02 1080.52 1012.99 1084.54 1011.94C1097.35 1008.61 1106.91 1005.01 1118.94 999.527C1121.27 1000.44 1124.45 997.733 1126.61 996.355Z",
    fill: "url(#paint27_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.323 931.214C563.902 929.126 577.567 921.472 587.559 913.708C590.269 911.602 593.817 906.575 597.332 906.562C604.773 913.524 578.724 928.532 573.744 930.828C567.243 933.822 551.941 940.196 544.934 940.154C540.685 944.476 537.339 948.065 532.479 951.757L532.23 951.947C524.398 957.696 515.804 961.731 506.027 962.539C501.015 962.956 494.451 963.427 490.485 959.753C489.03 958.406 488.134 956.674 488.144 954.659C488.214 940.068 522.367 941.139 528.667 934.875C530.862 935.561 548.903 932.855 551.323 931.214Z",
    fill: "url(#paint28_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.523 944.096C524.901 941.978 538.319 939.443 544.934 940.153C540.685 944.476 537.339 948.064 532.479 951.756L532.23 951.946L529.739 943.845L518.523 944.096Z",
    fill: "url(#paint29_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.171 944.391L519.348 944.556L519.316 945.425C512.076 951.855 507.692 955.89 497.6 955.908C496.879 954.714 497.072 955.045 496.69 953.667C499.064 947.96 513.275 945.707 519.171 944.391Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.684 692.753C517.353 695.215 524.468 698.454 531.043 701.289C552.138 707.503 572.518 716.541 594.36 721.489C598.359 722.395 622.555 729.302 625.01 730.82L624.459 731.567L625.383 731.898C626.29 734.904 623.54 743.25 622.304 746.495C621.477 748.644 617.509 747.083 615.189 747.959C610.089 747.512 575.125 738.639 570.297 736.717C569.163 735.657 565.899 734.672 564.256 734.096C552.779 730.036 540.387 724.666 529.858 718.519C524.66 715.739 517.364 711.937 512.963 708.146L513.256 707.179L515.404 708.618L516.366 708.287C518.632 703.817 519.285 702.697 520.359 697.841C516.818 696.653 512.992 695.662 510.684 692.753Z",
    fill: "url(#paint30_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.684 692.753C517.353 695.215 524.468 698.454 531.043 701.289C527.836 701.252 525.191 699.537 523.016 700.321C521.728 702.372 520.082 708.3 520.734 710.516C521.946 714.637 527.384 713.798 529.858 718.519C524.66 715.739 517.364 711.937 512.963 708.146L513.256 707.179L515.404 708.618L516.366 708.287C518.632 703.817 519.285 702.697 520.359 697.841C516.818 696.653 512.992 695.662 510.684 692.753Z",
    fill: "url(#paint31_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.827 662.156C473.84 670.275 481.235 676.649 491.941 682.895C497.488 686.128 505.672 689.526 510.684 692.753C512.992 695.662 516.818 696.653 520.359 697.841C519.285 702.697 518.632 703.817 516.366 708.287L515.404 708.618L513.256 707.179L512.963 708.146C501.616 702.066 469.177 673.325 464.827 662.156Z",
    fill: "url(#paint32_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.01 730.82C642.063 735.927 679.285 748.289 670.553 773.688C665.93 787.14 648.467 795.663 636.246 801.082L629.565 804.003L630.196 803.488C635.658 799.166 642.075 796.086 647.335 791.714C679.977 764.54 635.144 753.592 615.189 747.959C617.509 747.083 621.477 748.644 622.304 746.495C623.54 743.25 626.29 734.904 625.383 731.898L624.459 731.567L625.01 730.82Z",
    fill: "url(#paint33_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.713 1083.52C641.23 1077.68 648.351 1047.83 654.419 1049.93C658.203 1054.05 664.791 1076.86 666.8 1083.42C669.727 1074.57 673.621 1061.14 677.178 1052.31C677.76 1050.87 679.97 1049.97 681.581 1049.66C683.534 1050.22 682.922 1049.63 683.803 1051.09L682.077 1056.36C679.872 1062.9 671.594 1094.9 665.116 1093.73C662.422 1091.25 655.405 1066.56 652.68 1060.69C651.082 1065.5 644.591 1087.04 641.187 1092.31C640.881 1092.79 636.527 1092.79 636.282 1092.32C632.59 1085.07 623.963 1056.19 621.967 1050.01C623.387 1049.99 627.557 1049.77 627.943 1050.42C631.102 1055.79 637.232 1078.46 638.713 1083.52Z",
    fill: "url(#paint34_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.215 1074L292.497 1073.99L326.794 1073.99C331.22 1073.99 340.932 1073.7 344.705 1074.35C345.988 1076.06 345.513 1076.64 345.579 1079.33L219.753 1079.32L186.966 1079.32C182.664 1079.32 172.789 1079.62 169.168 1078.95C167.859 1077.1 168.321 1076.77 168.215 1074Z",
    fill: "url(#paint35_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.114 1074.04C954.999 1073.46 996.177 1074.04 1036.18 1073.99L1068.64 1073.95C1072.04 1073.95 1082.73 1073.69 1085.54 1074.36C1086.65 1076.06 1086.24 1076.92 1086.31 1079.35L966.756 1079.33L934.45 1079.33C930.127 1079.33 919.933 1079.58 916.338 1078.93C914.832 1077.08 915.334 1076.98 915.114 1074.04Z",
    fill: "url(#paint36_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.448 1049.82C412.877 1049.75 415.001 1049.45 416.842 1050.87C418.669 1055.13 434.63 1090.59 434.168 1092.64C426.947 1093.8 426.466 1088.06 424.127 1082.38L416.36 1082.47L402.638 1082.44C401.376 1085.44 399.554 1090.44 397.629 1092.76C395.736 1092.76 394.119 1092.99 392.504 1092.11C393.182 1088.9 397.307 1080.11 398.847 1076.61C402.817 1067.72 406.684 1058.8 410.448 1049.82Z",
    fill: "url(#paint37_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.349 1057.79C415.291 1060.66 420.197 1073.36 421.74 1077.18L412.771 1077.16L405.214 1077.09C407.83 1070.62 410.542 1064.18 413.349 1057.79Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.426 1049.94C731.625 1049.86 733.339 1049.56 735.341 1050.39C737.65 1055.26 753.337 1090.12 753.172 1092.57C751.243 1093.22 750.943 1093.02 748.941 1092.77C745.873 1090.64 744.495 1085.92 742.983 1082.3L736.045 1082.5L721.681 1082.47C720.554 1085.15 718.35 1091.62 716.176 1092.85C714.149 1092.91 713.421 1093.1 711.621 1092.15C711.853 1088.74 727.222 1055.07 729.426 1049.94Z",
    fill: "url(#paint38_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.126 1057.91C734.208 1060.22 739.211 1073.48 740.656 1077.1L733.406 1077.18L723.916 1077.15L732.126 1057.91Z",
    fill: "#FCF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.516 1049.6C863.95 1049.21 866.974 1050.82 873.116 1054.47C872.087 1055.95 870.863 1057.48 869.742 1058.92C864.072 1055.8 851.336 1050.93 850.057 1061.46C852.598 1070.01 873.661 1068.24 874.169 1080.11C874.592 1089.94 866.644 1093.1 857.974 1093.54C850.51 1092.42 848.679 1091.36 842.758 1087.16L846.279 1082.59C851.238 1086.29 855.818 1089.2 862.462 1087.69C864.948 1087.12 869.369 1083.51 867.924 1080.5C865.456 1075.39 857.6 1074.66 852.849 1072.35C849.885 1071.05 845.385 1068.19 844.57 1064.65C842.39 1055.25 848.899 1051.23 856.516 1049.6Z",
    fill: "url(#paint39_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.278 1070.14C799.639 1064.74 805.407 1054.7 809.118 1050.47C811.316 1049.76 812.461 1049.98 814.745 1050.09C814.843 1053.1 808.72 1061.36 806.711 1064.39L799.211 1075.94C799.045 1081 800.974 1090.34 796.602 1093.08C791.196 1092.39 793.075 1080.51 793.18 1076.22L776.476 1050C778.417 1049.93 782.611 1049.48 783.732 1050.96C788.152 1056.8 792.31 1063.96 796.278 1070.14Z",
    fill: "url(#paint40_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.907 1049.93C470.077 1049.88 471.592 1049.61 473.496 1050.59C474.324 1053.95 473.914 1082.24 473.896 1087.44C479.398 1087.42 490.881 1087.12 495.86 1087.73C496.847 1089.15 496.558 1091.11 496.563 1092.96L467.893 1093.02C467.73 1078.78 467.899 1064.19 467.907 1049.93Z",
    fill: "url(#paint41_linear_448_18446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.692 1049.99C532.206 1049.85 532.753 1049.68 535.096 1050.4C536.208 1053 535.613 1082.66 535.591 1087.45C540.983 1087.45 552.875 1087.02 557.583 1087.75C558.625 1089.15 558.326 1091.02 558.329 1092.89C549.199 1093.18 538.918 1092.96 529.701 1092.96L529.692 1049.99Z",
    fill: "url(#paint42_linear_448_18446)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_18446",
    x1: 425.863,
    y1: 440.466,
    x2: 688.297,
    y2: 440.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_18446",
    x1: 557.888,
    y1: 593.5,
    x2: 801.868,
    y2: 593.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_448_18446",
    x1: 550.98,
    y1: 317.888,
    x2: 802.474,
    y2: 317.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_448_18446",
    x1: 616.468,
    y1: 494.063,
    x2: 732.105,
    y2: 494.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_448_18446",
    x1: 577.959,
    y1: 334.006,
    x2: 655.204,
    y2: 334.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_448_18446",
    x1: 801.542,
    y1: 867.506,
    x2: 1096.92,
    y2: 867.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_448_18446",
    x1: 918.16,
    y1: 903.415,
    x2: 946.023,
    y2: 903.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_448_18446",
    x1: 914.391,
    y1: 893.936,
    x2: 978.212,
    y2: 893.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_448_18446",
    x1: 827.652,
    y1: 904.454,
    x2: 846.334,
    y2: 904.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_448_18446",
    x1: 90.8767,
    y1: 886.045,
    x2: 398.75,
    y2: 886.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_448_18446",
    x1: 358.101,
    y1: 875.538,
    x2: 575.063,
    y2: 875.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_448_18446",
    x1: 496.942,
    y1: 906.183,
    x2: 504.903,
    y2: 906.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_448_18446",
    x1: 385.458,
    y1: 903.875,
    x2: 422.535,
    y2: 903.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_448_18446",
    x1: 601.156,
    y1: 838.729,
    x2: 853.329,
    y2: 838.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_448_18446",
    x1: 671.561,
    y1: 956.974,
    x2: 948.729,
    y2: 956.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_448_18446",
    x1: 680.258,
    y1: 905.374,
    x2: 719.253,
    y2: 905.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_448_18446",
    x1: 638.701,
    y1: 948.085,
    x2: 711.823,
    y2: 948.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_448_18446",
    x1: 701.077,
    y1: 910.82,
    x2: 711.823,
    y2: 910.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_448_18446",
    x1: 700.464,
    y1: 854.922,
    x2: 777.78,
    y2: 854.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_448_18446",
    x1: 933.526,
    y1: 993.36,
    x2: 1155.26,
    y2: 993.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_448_18446",
    x1: 933.526,
    y1: 993.36,
    x2: 1155.26,
    y2: 993.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_448_18446",
    x1: 933.526,
    y1: 993.36,
    x2: 1155.26,
    y2: 993.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_448_18446",
    x1: 933.526,
    y1: 993.36,
    x2: 1155.26,
    y2: 993.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_448_18446",
    x1: 488.144,
    y1: 934.691,
    x2: 598.659,
    y2: 934.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_448_18446",
    x1: 518.523,
    y1: 945.989,
    x2: 544.934,
    y2: 945.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_448_18446",
    x1: 464.827,
    y1: 733.079,
    x2: 671.861,
    y2: 733.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_448_18446",
    x1: 464.827,
    y1: 733.079,
    x2: 671.861,
    y2: 733.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_448_18446",
    x1: 464.827,
    y1: 733.079,
    x2: 671.861,
    y2: 733.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_448_18446",
    x1: 464.827,
    y1: 733.079,
    x2: 671.861,
    y2: 733.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_448_18446",
    x1: 621.967,
    y1: 1071.71,
    x2: 683.803,
    y2: 1071.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_448_18446",
    x1: 168.215,
    y1: 1076.66,
    x2: 345.612,
    y2: 1076.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_448_18446",
    x1: 915.114,
    y1: 1076.58,
    x2: 1086.33,
    y2: 1076.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_448_18446",
    x1: 392.504,
    y1: 1071.27,
    x2: 434.178,
    y2: 1071.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_448_18446",
    x1: 711.621,
    y1: 1071.41,
    x2: 753.173,
    y2: 1071.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_448_18446",
    x1: 842.758,
    y1: 1071.54,
    x2: 874.185,
    y2: 1071.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_448_18446",
    x1: 776.476,
    y1: 1071.48,
    x2: 814.746,
    y2: 1071.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_448_18446",
    x1: 467.822,
    y1: 1071.44,
    x2: 496.599,
    y2: 1071.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_448_18446",
    x1: 529.692,
    y1: 1071.45,
    x2: 558.366,
    y2: 1071.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_18446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1254,
    height: 1254,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logoLogin.d1d8b22f01b96b5bc5d1177db0330da3.svg";
export { ForwardRef as ReactComponent };